import { LoggerService } from 'n2p-ui-library/services/logger/logger.service'
// import constants
import { getStorageJSON } from 'constants/LocalStorage'

const enabledTransports = ['console']
let logger = new LoggerService({
  appId: 'n2p-dialer',
  enabledTransports,
})

const initLogger = (environment) => {
  logger = new LoggerService({
    appId: 'n2p-dialer',
    environment,
    enabledTransports,
  })
}

const analyticsLogger = (events, action) => {
  if (!getStorageJSON()?.googleAnalytic) {
    return
  }

  if (events.length) {
    // eslint-disable-next-line no-console
    logger.logInfo(`Analytics - ${action.type}`, events[0])
  }
}

export default {
  info: (...args) => logger.logInfo(...args),
  error: (...args) => logger.logError(...args),
  critical: (...args) => logger.logCritical(...args),
  setConsoleInfoDebug: (...args) => logger.setConsoleInfoDebug(...args),
  toggleTransportType: (...args) => logger.toggleTransportType(...args),
  enabledTransports: logger.enabledTransports,
  transports: logger.transports,
  toggleConsoleDebug: (...args) => logger.toggleConsoleDebug(...args),
  analyticsLogger,
  initLogger,
}
